module.exports = __webpack_public_path__ + "fonts/mulish-v11-latin-700italic.b1d27fb.ttf";